<template>
  <v-container fluid>
    <v-layout row wrap>
      <!-- Widgets-->
      <WidgetGroup />
      <!-- Widgets Ends -->
      <!-- Statistics -->
      <v-flex d-flex xs12 class="my-4 px-4">
        <site-view-statistic />
      </v-flex>
      <!-- <v-flex d-flex xs12 class="my-4 px-4">
        <radar-statistic />
      </v-flex> -->
      <!-- Statistics Ends -->
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    Widget: () => import('@/components/admin/information/InfoCard'),
    SiteViewStatistic: () =>
      import('@/components/admin/statistic/SiteViewStatistic'),
    RadarStatistic: () => import('@/components/admin/statistic/RadarStatistic'),
    WidgetGroup: () => import('@/components/admin/information/ResumeCards')
  },
  data() {
    return {}
  },

  methods: {
    formatDate(date) {
      let options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }
      return `${new Date(date).toLocaleDateString('es-PE', options)} ${new Date(
        date
      ).toLocaleTimeString()}`
    }
  },

  computed: {
    ...mapGetters('user', ['fetching', 'getError'])
  }
}
</script>

<style>
</style>
